import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withSnackbar } from "notistack";
import get from "lodash/get";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import React from "react";
import { connect } from "react-redux";
import CallOutNew from "Component/Headers/callOutNew";
import { ErrorMessages } from "../../../../../../Constants";
import { instance } from "../../../../../../Actions/AxiosInstance";
import InputValues from "../../../../../../Component/FloatValues";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import { radioinputconverter } from "../../../../../../Component/DynamicForm/Fields/Radio";

const POST_DATA = {
  businessunitid: null, // 101
  activevariabledays: 1, // 10,
  fallbackactionid: 1, // 1,
  ismanagerrequired: null, // true
};

export class VariableComponent extends React.Component {
  state = {
    isallowvpf: false,
    postdata: POST_DATA,
    ...POST_DATA,
  };

  componentDidMount() {
    const {
      payrollconfigdata: { isseparatebusinessentity },
    } = this.props;
    this.getVpfData();
    if (isseparatebusinessentity) {
      this.GetBusinessUnits();
    } else {
      this.getdata();
    }
  }

  GetBusinessUnits = () => {
    const data = {
      featurekey: "misc",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        const businessUnits = [];
        businessUnits.push(...result.data.result);
        this.setState({ businessUnits });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  getdata = (buid) => {
    instance
      .get(`payroll/variableconfig${buid ? `/${buid}` : ""}`)
      .then((resp) => {
        this.setState(
          {
            postdata: get(resp, "data.result[0]", POST_DATA),
            ...get(resp, "data.result[0]", POST_DATA),
          },
          () => buid && this.updatepostdata("businessunitid", buid),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  submit = () => {
    const { postdata } = this.state;
    if (postdata.fallbackactionid == null) {
      this.props.enqueueSnackbar(ErrorMessages.E1420, { variant: "error" });
      return;
    }
    instance
      .post("payroll/variableconfig", postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.getpayrollconfig();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  handleChange = (key, value) => {
    console.log("key, value: ", key, value);
    this.setState({
      [key]: value,
    });
  }

  updatepostdata = (key, value) => {
    const data = {
      ...this.state.postdata,
      [key]: value,
    };
    this.setState({
      postdata: data,
      ...data,
    });
  };

  onVpfSetting = () => {
    const data = {
      vpfconfigid: null,
      isallowvpf: this.state.isallowvpf,
    };
    instance
      .post("payroll/vpfconfig", data)
      .then(() => {
        this.getVpfData();
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          {
            variant: "error",
          },
        );
      });
  }

  getVpfData = () => {
    instance.get('payroll/getvpfconfig').then((result) => {
      console.log('result: ', result);
      this.setState({ isallowvpf: result.data.result.length > 0 ? result.data.result[0].isallowvpf : false });
    }).catch((error) => {
      const CommonError = error.response
        ? error.response.data.error.message
        : error.message;
      this.props.enqueueSnackbar(CommonError, { variant: 'error' });
    });
  }

  render() {
    const {
      businessUnits = [],
      postdata: { businessunitid, activevariabledays, fallbackactionid },
    } = this.state;
    const {
      payrollconfigdata: { isseparatebusinessentity }, permissions ,
    } = this.props;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Misc.VariableComponentSettings.header}</title>
        </Helmet>
        <Grid container>
          <Grid md={12} xs={12} lg={12} sm={12}>
            {/* {isseparatebusinessentity && (
              <div className="padding-bottom-0 width80">
                <div className="width50">
                  <DynamicForm
                    fields={selectinputconverter({
                      placeholder: "Select business unit",
                      options: businessUnits,
                      value: businessunitid,
                    })}
                    onChange={(val) => {
                      this.getdata(val);
                    }}
                  />
                </div>
              </div>
            )} */}

            {(
              <div style={{
                backgroundColor: "#f7f8f8",
                marginBottom: 16,
                padding: 16,
              }}>
                <div>
                  <div>
                    <span className="position-rel">Activate Variable dashboard for managers</span>
                    <InputValues
                      min="1"
                      max="30"
                      field="lapsedays"
                      defaultvalue={1}
                      onChange={(e) => this.updatepostdata("activevariabledays", e.target.value)}
                      value={activevariabledays}
                      disabled={this.props.permissions && !this.props.permissions.editable }
                    />
                    <span className="position-rel">days before payroll run date.</span>
                  </div>
                </div>
                {/* <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8" }}>
                  <div className="small-dark-secondary margin-bottom-8">Fallback action if variable pay is not acted upon by manager</div>
                  <DynamicForm
                    fields={radioinputconverter({
                      value: fallbackactionid == 1,
                      label: "Release variable pay",
                      labelclass: "small-dark-secondary margin-top-2 t-bold",
                    })}
                    onChange={() => this.updatepostdata("fallbackactionid", 1)}
                  />
                  <DynamicForm
                    fields={radioinputconverter({
                      value: fallbackactionid == 2,
                      label: "Postpone to next month's payroll",
                      labelclass: "small-dark-secondary margin-top-2 t-bold",
                    })}
                    onChange={() => this.updatepostdata("fallbackactionid", 2)}
                  />
                  <DynamicForm
                    fields={radioinputconverter({
                      value: fallbackactionid == 3,
                      label: "Keep variable pay on hold indefinitely",
                      labelclass: "small-dark-secondary margin-top-2 t-bold",
                    })}
                    onChange={() => this.updatepostdata("fallbackactionid", 3)}
                  />
                </div> */}
                {this.props.permissions && this.props.permissions.editable  && 
                <Grid container>
                  <Grid item xs={12} md={6} sm={12} style={{ justifyContent: "flex-start", display: "flex" }}>
                    <div className="">
                      <Button className="btn btn-primary-md-blue margin-right-8" variant="contained" onClick={this.submit}>
                        Save
                      </Button>
                    </div>
                  </Grid>
                </Grid>
                }
              </div>
            )}
            <div style={{
              backgroundColor: "#f7f8f8",
              marginBottom: 32,
              padding: 16,
            }}>

              <p className="normal-dark-secondary margin-bottom-16">
                Do you want to allow VPF in your company ?
              </p>
              <span className="floatleft width20">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: this.state.isallowvpf == true,
                    label: "Yes",
                    disabled: this.props.permissions && !this.props.permissions.editable,
                  })}
                  onChange={() =>
                    this.handleChange("isallowvpf", true)
                  }
                />
              </span>
              <span className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: this.state.isallowvpf == false,
                    label: "No",
                    disabled: this.props.permissions && !this.props.permissions.editable,
                  })}
                  onChange={() => this.handleChange("isallowvpf", false)}
                />
              </span>

              <CallOutNew
                classnames="bg-light-blue width100"
                header="Once you start VPF for an employee then it can only be stopped in the next financial cycle. VPF is deducted from Employee Gross."
                // emoji="🔍 👩🏻‍💼 👜"
                textcolor="#1e8ced"
              />
{this.props.permissions && this.props.permissions.editable && 
              <Grid container>
                <Grid item xs={12} md={6} sm={12} style={{ justifyContent: "flex-start", display: "flex" }}>
                  <div className="margin-top-8">
                    <Button className="btn btn-primary-md-blue margin-right-8" variant="contained" onClick={this.onVpfSetting}>
                      Save
                      </Button>
                  </div>
                </Grid>
              </Grid>
}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(VariableComponent));
